// extracted by mini-css-extract-plugin
export default {"banner":"bonus_banner__D9ISe","buttons":"bonus_buttons__3IrNe","back":"bonus_back__Pk7Uw","box":"bonus_box__OHNOr"};